import React, { useState, useEffect } from 'react'

// Deps
import { connect } from 'react-redux'
import store from 'store'

// Controllers
import { setError } from 'controllers/navigator'

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Partials
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Btn from 'views/shared/partials/btn'

// Utils
import { openModal } from 'utils/modals'

// Services
import companyServices from 'services/company'
import commerceServices from 'services/commerce'
// import userServices from 'services/user'

// Hooks
import useGroups from 'hooks/groups'
import Loader from 'views/shared/partials/loader'

// Actions
import { setData } from 'store/user/actions'

// Constants
const deliveryMethods = [
	{
		value: '1',
		label: 'Mağazada Teslimat'
	},
	{
		value: '2',
		label: 'Adrese Teslimat'
	},
	{
		value: '3',
		label: 'Başka Mağazadan Teslimat'
	},
]

const terminalModes = [
	{
		value: 0,
		label: 'Deaktif',
	},
	{
		value: 1,
		label: 'Aktif',
	},
	{
		value: 2,
		label: 'Yalnızca Ürün Özellikleri Aktif',
	},
]

const multiplePaymentModes = [
	{
		value: 0,
		label: 'Aktif',
	},
	{
		value: 1,
		label: 'Deaktif',
	},
]

const mapStateToProps = state => {
	return {
		userData: state.user.data,
		companyInfo: state.user.data.company,
		userGroups: state.user.groups,
	};
};

const processCompanyInfo = (info) => {
	return {
		...info,
		product_delivery_methods: info.product_delivery_methods ? JSON.parse(info.product_delivery_methods) : [],
		product_terminal_permitted_ips: info.product_terminal_permitted_ips ? JSON.parse(info.product_terminal_permitted_ips) : [],
		home_delivery_store: info.home_delivery_store ? { ...info.home_delivery_store, value: info.home_delivery_store.store_code, label: info.home_delivery_store.name, } : null,
		product_terminal_status: info.product_terminal_status ? info.product_terminal_status : terminalModes[0].value,
	};
}

const ProductSettings = ({userGroups, userData, ...props}) => {
	const [companyInfo, setCompanyInfo] = useState(false)
	const [terminalStatus, setTerminalStatus] = useState(null);
	const [ipVal, setIpVal] = useState('');
	const [ipList, setIpList] = useState([]);
	const [xmlUrl, setXmlUrl] = useState('');
	const [storeXmlUrl, setStoreXmlUrl] = useState('');
	const [selectedDeliveryMethods, setSelectedDeliveryMethods] = useState([]);
	const [fetchedProductXmlUrl, setFetchedProductXmlUrl] = useState(false);
	const [fetchedStoreXmlUrl, setFetchedStoreXmlUrl] = useState(false);

	const [fetchingProductXml, setFetchingProductXml] = useState(false);
	const [fetchingStoreXml, setFetchingStoreXml] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	const groups = useGroups(userGroups, false);

	const getCompanyInfo = (reset = true) => {
		return new Promise((resolve, reject) => {
			if(reset) {
				setCompanyInfo(false);
			}
		
			companyServices.getCompany().then((companyInfo) => {
				const processedInfo = processCompanyInfo(companyInfo);

				// todo - company bilgisini güncelliyorum menünün güncellenmesi için
				// başka bir tarafı bozar mı emin olamadım kontrol ettim sorun yok gibi
				// bir problem olursa burayı kaldıracağız
				store.dispatch(setData({
					...userData,
					company: processedInfo
				}));

				setTerminalStatus(terminalModes.find(m => m.value === processedInfo.product_terminal_status));
				setIpList((processedInfo.product_terminal_permitted_ips && Array.isArray(processedInfo.product_terminal_permitted_ips)) ? processedInfo.product_terminal_permitted_ips : []);
				setXmlUrl(processedInfo.product_xml_url ? processedInfo.product_xml_url : '');
				setStoreXmlUrl(processedInfo.store_xml_url ? processedInfo.store_xml_url : '');
				setSelectedDeliveryMethods(processedInfo.product_delivery_methods && Array.isArray(processedInfo.product_delivery_methods) ? processedInfo.product_delivery_methods : [])
				setCompanyInfo(processedInfo);
				resolve();
			}).catch(() => {
				reject();
			});
		});
	}

	useEffect(() => {
		getCompanyInfo();
	}, [])

	const submit = (formData) => {
		setSubmitting(true);

		let newData = {
			product_terminal_status: '0',
		}

		if (terminalStatus.value !== 0) {
			newData = {
				...formData,
				product_delivery_methods: JSON.stringify(formData.product_delivery_methods),
				product_terminal_permitted_ips: JSON.stringify(ipList),
			}
		};

		companyServices.updateCompany(newData).then((payload) => {
			// userServices.me().catch(() => {
			// 	setError();
			// })
			// getCompanyInfo(false);
			getCompanyInfo().then(() => {
				setSubmitting(false);
			}).catch(() => {
				setError();
			})
		});
	}

	const addIp = () => {
		if (/^(?!\.)([0-9.]+)$/.test(ipVal)) {
			if(!ipList.includes(ipVal)){
				setIpList([...ipList, ipVal]);
				setIpVal('');
			}
		}
	}

	const removeIp = (ip, nth) => {
		openModal('confirm', {
			message: `<strong>${ip}</strong> numaralı IP adresini izinli adreslerden çıkarmak istediğinizden emin misiniz?`,
			onConfirm: () => {
				let newIpList = [...ipList]
				newIpList.splice(nth, 1);
				setIpList(newIpList);
				
			},
		})
	}

	const getProducts = () => {
		setFetchingProductXml(true);
		commerceServices.fetchProductsFromXml(xmlUrl).then((payload) => {
			setFetchedProductXmlUrl(xmlUrl);
		}).catch(() => {
		}).finally(() => {
			setFetchingProductXml(false);
		})
	}

	const testXmlUrl = () => {
		setFetchingProductXml(true);

		commerceServices.testXmlUrl(xmlUrl).then((payload) => {
			setFetchedProductXmlUrl(xmlUrl);
			openModal('message', {
				title: 'XML Kaynağı Başarılı',
				message: 'XML kaynak adresi başarılı bir şekilde getirildi.'
			})
		}).catch(() => {
			openModal('message', {
				title: 'XML Kaynağı Başarısız',
				message: 'XML kaynağı getirilirken bir hata ile karşılaşıldı. Adresi kontrol edip tekrar deneyin.'
			})
		}).finally(() => {
			setFetchingProductXml(false);
		})
	}

	const getStores = () => {
		setFetchingStoreXml(true);
		commerceServices.fetchStoresFromXml(storeXmlUrl).then((payload) => {
			setFetchedStoreXmlUrl(storeXmlUrl);
		}).catch(() => {
		}).finally(() => {
			setFetchingStoreXml(false);
		})
	}

	const testStoreXmlUrl = () => {
		setFetchingStoreXml(true);

		commerceServices.testXmlUrl(storeXmlUrl).then((payload) => {
			setFetchedStoreXmlUrl(storeXmlUrl);
			openModal('message', {
				title: 'XML Kaynağı Başarılı',
				message: 'XML kaynak adresi başarılı bir şekilde getirildi.'
			})
		}).catch(() => {
			openModal('message', {
				title: 'XML Kaynağı Başarısız',
				message: 'XML kaynağı getirilirken bir hata ile karşılaşıldı. Adresi kontrol edip tekrar deneyin.'
			})
		}).finally(() => {
			setFetchingStoreXml(false);
		})
	}

	return (
		<main className="page company-info">
			<Breadcrumbs />
			<InputForm className="portlet" onSubmit={submit}>
				<div className="portlet-header">
					<h1 className="portlet-title">Ürün Entegrasyon Ayarları</h1>
				</div>
				<div className="portlet-section loader-container">
					<Loader loading={!companyInfo} />
					{companyInfo &&
						<div className="grid-container">
							<div className="row">
								<div className="col x4">
									{/* <FormInput
										type="checkbox"
										disabled={fetching || submitting}
										checked={enabled}
										onChange={setEnabled}
										name="product_terminal_status"
										label="Ürün Entegrasyon Özelliklerini Aktive Et"
										value="1" /> */}

									<FormInput
										disabled={submitting}
										type="select"
										z="3"
										defaultOption={terminalModes[0]}
										label="Ürün Entegrasyon Özellikleri"
										value={terminalStatus}
										onChange={setTerminalStatus}
										options={terminalModes}
										name="product_terminal_status" />
								</div>
								<div className="col x4">
									<FormInput
										disabled={submitting}
										type="select"
										z="2"
										defaultOption={multiplePaymentModes[0]}
										label="Parçalı Ödeme"
										value={companyInfo.multiple_payment_off === 1 ? multiplePaymentModes[1] : multiplePaymentModes[0]}
										options={multiplePaymentModes}
										name="multiple_payment_off" />
								</div>
							</div>
							{terminalStatus?.value !== 0 &&
								<React.Fragment>
									<div className="row">
										<div className="col x8">
											<FormInput
												disabled={submitting}
												type="text"
												label="Ürün XML Kaynak Adresi"
												placeholder="Ürün XML kaynak adresini girin"
												name="product_xml_url"
												autoComplete="product_xml_url"
												validation={{
													required: 'Bir XML adresi girmelisiniz.',
													url: 'Geçerli bir URL girmelisiniz.',
												}}
												onChange={setXmlUrl}
												value={xmlUrl} />
										</div>
										{(companyInfo.product_xml_url && companyInfo.product_xml_url.length && companyInfo.product_xml_url === xmlUrl) ?
											<div className="col x2">
												<Btn
													onClick={getProducts}
													loading={fetchingProductXml}
													disabled={xmlUrl === fetchedProductXmlUrl}
													status={xmlUrl === fetchedProductXmlUrl ? 'success' : undefined}
													icon="product"
													block big>
													Ürünleri Getir
												</Btn>
											</div>
											:
											<div className="col x2">
												<Btn
													onClick={testXmlUrl}
													loading={fetchingProductXml}
													disabled={!xmlUrl.length || xmlUrl === fetchedProductXmlUrl}
													status={xmlUrl === fetchedProductXmlUrl ? 'success' : undefined}
													icon="info"
													block big>
													Adresi Test Et
												</Btn>
											</div>
										}
									</div>
									<div className="row">
										<div className="col x8">
											<FormInput
												disabled={submitting}
												type="text"
												label="Mağaza XML Kaynak Adresi"
												placeholder="Mağaza XML kaynak adresini girin"
												name="store_xml_url"
												autoComplete="store_xml_url"
												validation={{
													required: 'Bir XML adresi girmelisiniz.',
													url: 'Geçerli bir URL girmelisiniz.',
												}}
												onChange={setStoreXmlUrl}
												value={storeXmlUrl} />
										</div>
										{(companyInfo.store_xml_url && companyInfo.store_xml_url.length && companyInfo.store_xml_url === storeXmlUrl) ?
											<div className="col x2">
												<Btn
													onClick={getStores}
													loading={fetchingStoreXml}
													disabled={storeXmlUrl === fetchedStoreXmlUrl}
													status={storeXmlUrl === fetchedStoreXmlUrl ? 'success' : undefined}
													icon="product"
													block big>
													Mağazaları Getir
												</Btn>
											</div>
											:
											<div className="col x2">
												<Btn
													onClick={testStoreXmlUrl}
													loading={fetchingStoreXml}
													disabled={!storeXmlUrl.length || storeXmlUrl === fetchedStoreXmlUrl}
													status={storeXmlUrl === fetchedStoreXmlUrl ? 'success' : undefined}
													icon="info"
													block big>
													Adresi Test Et
												</Btn>
											</div>
										}
									</div>
									<div className="row">
										<div className="col x10">
											<FormInput
												disabled={submitting}
												type="text"
												label="Kampanya API Adresi"
												placeholder="Kampanya API adresini girin"
												name="product_campaign_api"
												autoComplete="product_campaign_api"
												validation={{
													url: 'Geçerli bir URL girmelisiniz.',
												}}
												value={companyInfo ? companyInfo.product_campaign_api : undefined} />
										</div>
									</div>
									<div className="row">
										<div className="col x4">
											<FormInput
												disabled={submitting}
												type="text"
												label="Üye Aktarım Sistemi Servis Adresi"
												placeholder="Aktarım servis adresini girin"
												name="erp_client_api"
												autoComplete="erp_client_api"
												validation={{
													url: 'Geçerli bir URL girmelisiniz.',
												}}
												value={companyInfo ? companyInfo.erp_client_api : undefined} />
										</div>
										<div className="col x4">
											<FormInput
												disabled={submitting}
												type="text"
												label="Sipariş Aktarım Sistemi Servis URL"
												placeholder="Aktarım servis adresini girin"
												name="erp_order_api"
												autoComplete="erp_order_api"
												validation={{
													url: 'Geçerli bir URL girmelisiniz.',
												}}
												value={companyInfo ? companyInfo.erp_order_api : undefined} />
										</div>
										<div className="col x4">
											<FormInput
												disabled={submitting}
												type="text"
												label="Sipariş İade Sistemi Servis URL"
												placeholder="İade servis adresini girin"
												name="erp_refund_api"
												autoComplete="erp_refund_api"
												validation={{
													url: 'Geçerli bir URL girmelisiniz.',
												}}
												value={companyInfo ? companyInfo.erp_refund_api : undefined} />
										</div>
									</div>
									<div className="row">
										<div className="col x8">
											<FormInput
												disabled={submitting}
												type="text"
												label="Aktarım Servisleri Token"
												placeholder="Token girin"
												name="erp_access_token"
												autoComplete="erp_access_token"
												value={companyInfo ? companyInfo.erp_access_token : undefined} />
										</div>
									</div>
									<div className="row apart">
										<div className="col x12">
											<FormInput
												disabled={submitting}
												type="checkbox"
												label="Teslimat Yöntemleri"
												options={deliveryMethods}
												value={selectedDeliveryMethods}
												onChange={setSelectedDeliveryMethods}
												name="product_delivery_methods" />
										</div>
									</div>
									{selectedDeliveryMethods && selectedDeliveryMethods.includes('2') &&
										<div className="row">
											<div className="col x6">
												<FormInput
													disabled={submitting || !groups}
													type="select"
													isSearchable
													z="1"
													readOnly={groups && groups.length < 1}
													defaultOption={(groups && groups.length === 1) ? groups[0] : undefined}
													label="İnternet Deposu Seçimi"
													validation={{
														required: "Bir depo seçmelisiniz."
													}}
													value={companyInfo.home_delivery_store}
													placeholder="Bir depo seçin"
													options={groups}
													name="home_delivery_store_code" />
											</div>
										</div>
									}
									<div className="row">
										<div className="col x4">
											<div className="portlet dark">
												<div className="portlet-header small">
													<h1 className="portlet-title">İzinli IP Adresleri</h1>
												</div>
												<div className="portlet-section bottom">
													<div className="row">
														<div className="col flex">
															<FormInput
																disabled={submitting}
																type="ip"
																onChange={setIpVal}
																name={false}
																onKeyPress={(e) => {
																	if(e.nativeEvent.keyCode === 13) { e.preventDefault(); addIp(); }
																}}
																value={ipVal}
																placeholder="Ekleyeceğiniz IP Adresini Yazın" />
														</div>
														<div className="col free">
															<Btn small icon="plus" onClick={addIp}>Ekle</Btn>
														</div>
													</div>
													{ipList.map((ip, nth) => (
														<div className="row" key={nth}>
															<div className="col flex">
																{ip}
															</div>
															<div className="col free">
																<Btn
																	error plain
																	onClick={() => { removeIp(ip, nth); }}
																	icon="trash" />
															</div>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
								</React.Fragment>
							}
						</div>
					}
				</div>
				{companyInfo &&
					<div className="portlet-section bottom align-right border-top">
						<Btn
							type="submit"
							loading={submitting}
							disabled={submitting}>
							Entegrasyon Ayarlarını Güncelle
						</Btn>
					</div>
				}
			</InputForm>
		</main>
	)
}
export default connect(mapStateToProps)(ProductSettings);